import React, { useState, useEffect } from "react";
import Select from "react-select";
import logo from "../images/navbar/newlogo.png";
import EmpOptions from "./EmpOptions";
import { useNavigate } from "react-router-dom";
import CandidateOpt from "./CandidateOpt";
import StaffOptions from "./StaffOptions";

function NavbarMob() {
    const navigate = useNavigate();
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [showOptions, setShowOptions] = useState(false);

    const companyName = sessionStorage.getItem("customerName");
    const customerType = sessionStorage.getItem("customerType");
    const selectedPlan = sessionStorage.getItem("selectedPlan") || "null";

    // const [job, setJob] = useState("");
    const [locationInput, setLocationInput] = useState("");
    const [locationOptions, setLocationOptions] = useState([]);
    const [locationError, setLocationError] = useState("");
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

    useEffect(() => {
        const fetchLocationData = async () => {
            try {
                const response = await fetch(`${apiBaseUrl}/data`);
                if (!response.ok) return;
                const data = await response.json();
                const districts = data?.states?.flatMap((s) => s.districts || []) || [];
                const unique = [...new Set(districts)].sort();
                setLocationOptions(unique.map((d) => ({ value: d, label: d })));
            } catch (err) {
                console.error("Failed to load locations", err);
            }
        };
        if (apiBaseUrl) fetchLocationData();
    }, [apiBaseUrl]);

    const home = () => navigate("/home");
    const login = () => navigate("/login");
    const regchooses = () => navigate("/regchoose");
    const findJob = () => {
        if (!locationInput) {
            setLocationError("Select a location.");
            return;
        }
        if (locationInput) {
            const exists = locationOptions.some((o) => o.value.toLowerCase() === locationInput.toLowerCase());
            if (!exists) {
                setLocationError("Select a location from the list.");
                return;
            }
        }
        setLocationError("");
        const params = new URLSearchParams();
        // Job name field hidden as requested. Keep this filter line for future reuse.
        // if (job && job !== "All") params.append("job", job);
        if (locationInput) params.append("location", locationInput);
        navigate(`/searchedjobs?${params.toString()}`);
    };

    const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);
    const toggleOptions = () => setShowOptions(!showOptions);
    const closeOptions = () => setShowOptions(false);

    return (
        <div className="w-full bg-white shadow-sm">
            {/* Top Bar */}
            <div className="flex items-center justify-between px-3 pt-3 pb-2">
                <img
                    src={logo}
                    alt="logo"
                    className="w-[45%] max-w-[180px] h-auto object-contain cursor-pointer"
                    onClick={home}
                />

                <div className="flex items-center gap-4 sm:gap-6">
                    {!customerType && (
                        <>
                            <span
                                className="text-base font-medium text-[#E22E37] cursor-pointer whitespace-nowrap"
                                onClick={login}
                            >
                                Login
                            </span>
                            <span
                                className="text-base font-medium text-[#E22E37] cursor-pointer whitespace-nowrap"
                                onClick={regchooses}
                            >
                                Free Register
                            </span>
                        </>
                    )}

                    {companyName && (
                        <div
                            className="px-4 py-1.5 bg-[#E22E37] rounded-md flex items-center cursor-pointer min-w-0"
                            onClick={toggleOptions}
                        >
                            <span className="text-sm font-semibold text-white truncate max-w-[200px]">{companyName}</span>
                        </div>
                    )}
                </div>

                <button onClick={toggleSidebar} className="p-1 text-gray-700">
                    <svg className="h-7 w-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16m-7 6h7" />
                    </svg>
                </button>
            </div>

            {/* Search Section */}
            {(!customerType ||
                customerType === "admin" ||
                customerType === "mainAdmin" ||
                (customerType === "candidate" && selectedPlan === "null")) && (
                <div className="px-3 pb-4 flex flex-col gap-2">
                    {/* Job name search hidden as requested. Keep this block for future reuse.
                    <input
                        type="text"
                        value={job}
                        onChange={(e) => setJob(e.target.value)}
                        onKeyDown={(e) => e.key === "Enter" && findJob()}
                        placeholder="Search job name..."
                        className="w-full h-10 px-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500"
                    />
                    */}

                    <div className="w-full flex flex-col gap-1">
                        <div className="w-full flex items-center gap-3">
                            {/* Select takes most of the space */}
                            <div className="flex-1 min-w-0">
                                <div className="w-full h-14 rounded-md border border-gray-300">
                                    <Select
                                        options={locationOptions}
                                        value={locationOptions.find((o) => o.value === locationInput) || null}
                                        onChange={(opt) => {
                                            setLocationInput(opt?.value || "");
                                            setLocationError("");
                                        }}
                                        placeholder="Select location..."
                                        classNamePrefix="react-select"
                                        styles={{
                                            control: (base) => ({
                                                ...base,
                                                minHeight: "54px",
                                                border: "none",
                                                boxShadow: "none",
                                            }),
                                            dropdownIndicator: (base) => ({ ...base, padding: 4 }),
                                            indicatorsContainer: (base) => ({ ...base, paddingRight: 8 }),
                                        }}
                                        isClearable
                                    />
                                </div>
                            </div>

                            {/* Button stays compact */}
                            <button
                                className="h-14 px-6 bg-[#E22E37] text-white font-bold text-base cursor-pointer hover:bg-red-700 transition-colors rounded-md whitespace-nowrap"
                                onClick={findJob}
                            >
                                Find Job
                            </button>
                        </div>

                        {locationError && <p className="text-red-500 text-xs px-1 mt-1">{locationError}</p>}
                    </div>
                </div>
            )}

            {/* Sidebar */}
            {isSidebarOpen && (
                <>
                    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-40" onClick={toggleSidebar} />
                    <div
                        className={`fixed top-0 left-0 w-[260px] h-full bg-black text-white z-50 transition-transform duration-300 ${
                            isSidebarOpen ? "translate-x-0" : "-translate-x-full"
                        }`}
                    >
                        <div className="p-4 flex justify-end">
                            <button
                                onClick={toggleSidebar}
                                className="px-3 py-1 bg-[#E22E37] border-2 border-white rounded hover:bg-red-700"
                            >
                                X
                            </button>
                        </div>

                        <ul className="mt-2">
                            <li className="p-4 hover:bg-gray-800 cursor-pointer" onClick={home}>
                                Home
                            </li>
                            {customerType && (
                                <li
                                    className="p-4 hover:bg-gray-800 cursor-pointer"
                                    onClick={() => navigate("/searchedjobs")}
                                >
                                    Find Jobs
                                </li>
                            )}
                            {(customerType === "admin" || customerType === "mainAdmin") && (
                                <>
                                    <li
                                        className="p-4 hover:bg-gray-800 cursor-pointer"
                                        onClick={() => navigate("/jobcategories")}
                                    >
                                        Job By Categories
                                    </li>
                                    <li
                                        className="p-4 hover:bg-gray-800 cursor-pointer"
                                        onClick={() => navigate("/jobnames")}
                                    >
                                        Job Names
                                    </li>
                                    <li
                                        className="p-4 hover:bg-gray-800 cursor-pointer"
                                        onClick={() => navigate("/martialstatus")}
                                    >
                                        Marital Status
                                    </li>
                                </>
                            )}
                            <li className="p-4 hover:bg-gray-800 cursor-pointer" onClick={() => navigate("/jobid")}>
                                Job ID Search
                            </li>
                            <li className="p-4 hover:bg-gray-800 cursor-pointer" onClick={() => navigate("/whatsapp")}>
                                Whatsapp
                            </li>
                        </ul>
                    </div>
                </>
            )}

            {/* Options dropdown for logged-in users */}
            {showOptions &&
                (customerType === "admin" || customerType === "mainAdmin" ? (
                    <StaffOptions closeOptions={closeOptions} />
                ) : customerType === "employee" ? (
                    <EmpOptions closeOptions={closeOptions} />
                ) : customerType === "candidate" ? (
                    <CandidateOpt closeOptions={closeOptions} />
                ) : null)}
        </div>
    );
}

export default NavbarMob;
